import { FC, useState } from "react";
import { IActivityEntry } from "@hulanbv/platformapp";
import { classes, stylesheet } from "typestyle";
import { Flex } from "../../../elements/flex.element";
import { Button } from "../../../elements/button.element";

type Props = {
  values: IActivityEntry[];
  onConfirm: (keptValues: IActivityEntry[]) => void;
};

const ThoughtsOnCardsSelectionView: FC<Props> = ({ values, onConfirm }) => {
  const [keptValues, setKeptValues] = useState<IActivityEntry[]>([]);
  const requiredNumberOfValues = 1;

  return (
    <Flex direction="column" alignItems="stretch" flex={1}>
      <Flex direction="column" flex={0}>
        <p className={styles.info}>
          Choose a value that feels important to you right now.
        </p>
      </Flex>

      <Flex
        direction="column"
        justifyContent="flex-start"
        flex={1}
        style={{ gap: 15, flexWrap: "wrap", padding: 20 }}
      >
        {values.map((value, index) => {
          const isSelected = keptValues.find(
            (selectedValue) => selectedValue.id === value.id,
          );
          return (
            <Flex
              key={value.id}
              attributes={{
                onClick: () => {
                  if (isSelected) {
                    setKeptValues(
                      keptValues.filter(
                        (selectedValue) => selectedValue.id !== value.id,
                      ),
                    );
                  } else if (keptValues.length < requiredNumberOfValues) {
                    setKeptValues(keptValues.concat(value));
                  }
                },
                className: classes(
                  styles.card,
                  isSelected && styles.selectedCard,
                ),
              }}
            >
              {value.input}
            </Flex>
          );
        })}
      </Flex>

      <Flex direction="row" justifyContent="center" flex={0}>
        <Button
          hideSpinnerOnSubmit
          centerChildren
          attributes={{
            disabled: keptValues.length < requiredNumberOfValues,
            onClick: () => onConfirm(keptValues),
          }}
        >
          {keptValues.length === requiredNumberOfValues && "Confirm Selection"}
          {keptValues.length < requiredNumberOfValues &&
            `Select ${requiredNumberOfValues - keptValues.length} More`}
        </Button>
      </Flex>
    </Flex>
  );
};

export { ThoughtsOnCardsSelectionView };

const styles = stylesheet({
  info: {
    fontSize: ".9em",
    color: "rgb(var(--rgb-color-text-tertiary))",
    textAlign: "center",
    margin: 0,
  },

  card: {
    borderRadius: 15,
    boxShadow: "0 2px 5px 0 rgba(var(--rgb-color-black), 0.1)",
    backgroundColor: "rgb(var(--rgb-color-white))",
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    padding: "20px",
    border: "1px solid transparent",
    textAlign: "center",
  },

  selectedCard: {
    borderColor: "rgb(var(--rgb-color-primair-basis))",
    fontWeight: "bold",
    color: "rgb(var(--rgb-color-primair-basis))",
  },
});
